import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Monitor } from 'lucide-react';
import { useProspecting, useProspectingSearch } from '../context/ProspectingContext';
import SimpleModeWorkspace from '../components/Prospecting/SimpleModeWorkspace';
import AdvancedModeWorkspace from '../components/Prospecting/AdvancedModeWorkspace';

function NarrowScreenNotice() {
  return (
    <div className="xl:hidden h-screen flex items-center justify-center bg-white dark:bg-gray-900 px-6">
      <div className="max-w-sm text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gray-100 dark:bg-gray-800 mb-3">
          <Monitor className="w-5 h-5 text-gray-400" />
        </div>
        <div className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
          Open Prospecting on a wider screen
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          The three-panel workspace is designed for desktop. Rotate to landscape or open on a larger display to use it.
        </p>
      </div>
    </div>
  );
}

export default function ProspectingWorkspace() {
  const { searchId } = useParams();
  const navigate = useNavigate();
  const { setActiveSearch } = useProspecting();
  const search = useProspectingSearch(searchId);

  useEffect(() => {
    if (searchId) setActiveSearch(searchId);
  }, [searchId, setActiveSearch]);

  // If the search doesn't exist (e.g. direct nav after refresh), bounce to landing
  useEffect(() => {
    if (searchId && !search) {
      navigate('/prospecting', { replace: true });
    }
  }, [searchId, search, navigate]);

  if (!search) return null;

  return (
    <>
      <NarrowScreenNotice />
      <div className="hidden xl:flex h-screen flex-col bg-white dark:bg-gray-900 overflow-hidden">
        {search.mode === 'advanced' ? (
          <AdvancedModeWorkspace search={search} />
        ) : (
          <SimpleModeWorkspace search={search} />
        )}
      </div>
    </>
  );
}
